import { authorizedFetch } from "./base";
import {
  ListingSearchResult,
  ExternalMarketSearchResult,
  NewListingDetails,
  TickerRequestCreate,
  TickerRequestResponse,
  TickerRequestBatchResponse,
} from "./types";

export async function searchListings(
  query: string,
  excludeEtf: boolean = false,
): Promise<ListingSearchResult[]> {
  const trimmed = query.trim();
  if (trimmed.length < 1) {
    return [];
  }

  const params = new URLSearchParams({ q: trimmed });
  if (excludeEtf) params.append("exclude_etf", "true");
  return authorizedFetch<ListingSearchResult[]>(
    `/listings/search?${params.toString()}`,
  );
}

export async function searchExternalListings(
  query: string,
): Promise<ExternalMarketSearchResult[]> {
  const trimmed = query.trim();
  if (trimmed.length < 1) {
    return [];
  }

  return authorizedFetch<ExternalMarketSearchResult[]>(
    `/market-data/search-external?q=${encodeURIComponent(trimmed)}`,
  );
}

export async function createListing(
  data: NewListingDetails,
): Promise<ListingSearchResult> {
  return authorizedFetch<ListingSearchResult>("/listings", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function createTickerRequest(
  data: TickerRequestCreate,
): Promise<TickerRequestResponse> {
  return authorizedFetch<TickerRequestResponse>("/listings/requests", {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function createTickerRequestsBatch(
  data: TickerRequestCreate[],
): Promise<TickerRequestBatchResponse> {
  return authorizedFetch<TickerRequestBatchResponse>(
    "/listings/requests/batch",
    {
      method: "POST",
      body: JSON.stringify({ requests: data }),
    },
  );
}
